import { render, staticRenderFns } from "./InfoList.vue?vue&type=template&id=2f259a80&scoped=true"
import script from "./InfoList.vue?vue&type=script&lang=js"
export * from "./InfoList.vue?vue&type=script&lang=js"
import style0 from "./InfoList.vue?vue&type=style&index=0&id=2f259a80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f259a80",
  null
  
)

export default component.exports